import { render, staticRenderFns } from "./RelativeTime.global.vue?vue&type=template&id=eb210b8e&lang=pug&"
import script from "./RelativeTime.global.vue?vue&type=script&lang=ts&"
export * from "./RelativeTime.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports